import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
var token = cookies.get('token');

export function fetchClients () {
	return function(dispatch) {
		axios.get(window.api+'client?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_CLIENTS_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_CLIENTS_REJECTED', payload: error});
			})
	}
}

export function fetchClientsByBrand(brand_id, year) {
	return function(dispatch) {
		axios.post(window.api+'clientByBrand?token='+token, {
			brand_id: brand_id,
			year: year,
		})
			.then((response) => {
				dispatch({type: 'FETCH_CLIENTS_BRAND_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_CLIENTS_BRAND_REJECTED', payload: error});
			})
	}
}

export function fetchClientAddress (client) {
	return function(dispatch) {
		axios.post(window.api+'client/address?client='+client+'&token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_CLIENTS_ADDRESS_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_CLIENTS_REJECTED', payload: error});
			})
	}
}

export function createClient (name, contact, address, zip, city, country, tel, fax, email, vat, bank, bankAccount, prefix, description, deliveryAddress, name_en) {
	return function(dispatch) {
		axios.post(window.api+'client?token='+token, {
                name: name,
                contact: contact,
                address: address,
                zip: zip,
                city: city,
                country: country,
                tel: tel,
                fax: fax,
                email: email,
                vat: vat,
                bank: bank,
                bank_account: bankAccount,
                prefix: prefix,
                description: description,
                delivery_address: deliveryAddress,
				name_en: name_en
			})
			.then((response) => {
				dispatch({type: 'CREATE_CLIENT_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'CREATE_CLIENT_REJECTED', payload: error});
			});
			
		return Promise.resolve();
	}
}

export function clearClient () {
	return function(dispatch) {
	// 	axios.get(window.api+'client/'+id+'?token='+token)
	// 		.then((response) => {
	// 			dispatch({type: 'FETCH_CLIENT_FULFILLED', payload: response.data});
	// 		})
	// 		.catch((error) => {
				dispatch({type: 'CLEAR_CLIENT', payload: []});
			// });

		return Promise.resolve();
	}
}

export function clearClientProducts () {
	return function(dispatch) {
		dispatch({type: 'CLEAR_CLIENT_PRODUCTS', payload: []});

		return Promise.resolve();
	}
}

export function fetchClient (id) {
	return function(dispatch) {
		axios.get(window.api+'client/'+id+'?token='+token)
			.then((response) => {
				dispatch({type: 'FETCH_CLIENT_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'FETCH_CLIENT_REJECTED', payload: error});
			});

		return Promise.resolve();
	}
}

export function updateClient (id, name, contact, address, zip, city, country, tel, fax, email, vat, bank, bankAccount, prefix, description, deliveryAddress, name_en, invoice_email) {
	return function(dispatch) {
		axios.put(window.api+'client/'+id+'?token='+token, {
				name: name,
                contact: contact,
                address: address,
                zip: zip,
                city: city,
                country: country,
                tel: tel,
                fax: fax,
                email: email,
                vat: vat,
                bank: bank,
                bank_account: bankAccount,
                prefix: prefix,
                description: description,
                delivery_address: deliveryAddress,
				name_en: name_en,
				invoice_email: invoice_email,
			})
			.then((response) => {
				dispatch({type: 'UPDATE_CLIENT_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'UPDATE_CLIENT_REJECTED', payload: error});
			});
			
		return Promise.resolve();
	}
}

export function deleteClient (id) {
	return function(dispatch) {
		axios.delete(window.api+'client/'+id+'?token='+token)
			.then((response) => {
				dispatch({type: 'DELETE_CLIENT_FULFILLED', payload: response.data});
			})
			.catch((error) => {
				dispatch({type: 'DELETE_CLIENT_REJECTED', payload: error});
			});

		return Promise.resolve();
	}
}

